<template>
  <p class="desc">
    このフォームはマイナビが運営する医師向けサービスサイト、<span>「ヒポクラ」「マイナビDOCTOR」にも同時に登録されます。</span>医学⽣‧医師のみなさんにお役⽴ていただけるサイトですのでぜひご利⽤ください。
  </p>
  <p class="caption">
    ＊ヒポクラ‧マイナビDOCTORへの同時登録を希望しない場合、登録内容の確認画⾯でそれぞれのチェックを外してください。
  </p>
  <div class="modalBtn">
    <Button
      label="ヒポクラ、マイナビDOCTORとは"
      :handleClick="
        () => {
          openHpcrDoctorModal()
        }
      "
      primary
      border
      wide303
    />
  </div>
  <ModalHpcrDoctor
    v-if="hpcrDoctorModal.isShow"
    :closeModal="closeHpcrDoctorModal"
  />
</template>
<script lang="ts">
import { reactive, defineComponent } from 'vue'
import Button from '@/components/elements/Button.vue'
import ModalHpcrDoctor from '@/components/block/ModalHpcrDoctor.vue'
export default defineComponent({
  name: 'RegisterIntro',
  components: { Button, ModalHpcrDoctor },
  setup() {
    const hpcrDoctorModal = reactive({
      isShow: false
    })
    const closeHpcrDoctorModal = () => (hpcrDoctorModal.isShow = false)
    const openHpcrDoctorModal = () => (hpcrDoctorModal.isShow = true)

    return {
      hpcrDoctorModal,
      closeHpcrDoctorModal,
      openHpcrDoctorModal
    }
  }
})
</script>
<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.desc {
  font-size: 1.4rem;
  line-height: 2;
  span {
    font-weight: bold;
  }
}
.caption {
  margin-top: 16px;
  font-size: 1.2rem;
  padding-left: 1em;
  line-height: 1.5;
  &::first-letter {
    margin-left: -1em;
  }
  @include mixins.media() {
    margin-top: 20px;
  }
}
.modalBtn {
  margin: 32px 0 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid var.$color-border-gray;
  @include mixins.media() {
    margin: 32px 0 40px;
    padding-bottom: 56px;
  }
}
</style>
